module.exports = __webpack_public_path__ + "images/backgrounds/river/small.15967f866d002762d13d.jpg";